import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'customer-item',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
  ],
  template: `
  <div class="fx-row fx-center p-3 radius-4 customer-item-bg">
    <mat-icon
      class="s-12 min-s-12"
      [svgIcon]="svgIcon">
    </mat-icon>
    <div class="fx-col ml-3 fx-g-1">
      <span class="text-grey-400 text-uppercase tw-text-sm tw-font-medium">{{ deviceItemContent }}</span>
      <span
        *ngIf="deviceItemSubContent"
        class="tw-text-sm text-grey-300">
        {{ deviceItemSubContent }}
      </span>
    </div>
    <div class="fx-row fx-g-0 fx-b-0">
      <button
        *ngIf="primaryAction"
        class="fx-center fx-row text-grey-400 {{ primaryAction.classes }}"
        data-testid="customer-item-primary-action"
        mat-icon-button
        [matTooltip]="primaryAction.hoverText || ''"
        (click)="primaryAction.clickFn()">
        <mat-icon>{{ primaryAction.icon }}</mat-icon>
      </button>
      <button
        *ngIf="secondaryAction"
        class="fx-center fx-row text-grey-400 {{ secondaryAction.classes }}"
        data-testid="customer-item-secondary-action"
        mat-icon-button
        [matTooltip]="secondaryAction.hoverText || ''"
        (click)="secondaryAction.clickFn()">
        <mat-icon>{{ secondaryAction.icon }}</mat-icon>
      </button>
    </div>
  </div>
  `,
  styleUrls: ['./customer-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerItemComponent {
  @Input() svgIcon = 'customer_inverter';
  @Input() deviceItemContent = '';
  @Input() deviceItemSubContent = '';
  @Input() primaryAction?: {
    icon: string;
    clickFn: () => void | Promise<void>;
    classes: string;
    hoverText?: string;
  };
  @Input() secondaryAction?: {
    icon: string;
    clickFn: () => void | Promise<void>;
    classes: string;
    hoverText?: string;
  };
}
